import React, { useEffect, useMemo } from "react";
import UserTaskList from "./component";
import UserTaskCardView from "../user-task-card-view";
import MdaeSwitch from "../common_widgets/switch";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
import { TOGGLE_CARD_VIEW_SWITCH } from "./reducers/audit-view-user-task-list-reducer";
import { GET_USER_TASK_DATASOURCE } from "./services/get-user-task-datasource";
import { resetAddTaskPopupValidation, USER_TASK_POPUP_MODE } from "./component";
import { actions, callOperation } from "async-ops";
import {
  defaultUserTaskFormData,
  SET_ASSIGNED_USER_TYPE,
  SET_CURRENT_ATTACHED_LEVEL_DATA,
  SET_USER_TASK_FORM_DATA,
  SET_USER_TASK_POPUP_MODE,
  TOGGLE_ADD_USER_TASK_POPUP,
} from "./reducers/user-task-list-reducer";
import { bindActionCreators } from "redux";
import { GET_ATTACHMENT_LEVEL_LIST } from "./services/get-attachment-level-list";
import { GET_AUDITOR_LIST } from "./services/get-auditor-list";
import { GET_USER_TASK_STATUS_LIST } from "./services/get-user-task-status-list";
import AddUserTaskPopup from "./add-user-task";
import { GET_USER_TASK_LIST_BY_LEVEL } from "./services/get-user-task-list-by-level";
import { SET_REFRESH_AUDIT_SUMMARY_DATA } from "../../pages/external-audit/reducers/external-audit-reducer";
import {
  FG_AUDIT_PROPERTY_EDITING,
  hasAnyFeatureGroupAccess,
} from "../user-permissions-helper";
import { refreshCaseListFromDb } from "../../pages/external-audit/case-list/case-list-detail";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../../pages/user-management/external-users/services/get-active-external-user-list-for-user-group";
import { getUserPreference, setUserPreference } from "../../utils/commom-utils";
import { GET_EXTERNAL_USER_GROUP_LIST } from "../../pages/user-management/external-users/services/get-external-user-group-list";
import { GET_TASK_GROUP_LIST } from "../../pages/user-management/task-groups/services/get-task-group-list";
import { USER_TYPE } from "./constant";
interface IAuditViewUserTaskList {
  attachedLevelId: number;
  attachedLevelName: string;
  includeNonAttachedLevelTasks?: boolean;
  auditGroupId?: number;
  isManagerView?: boolean;
  myTaskWidgetId: string;
  myPastDueTaskDrawerId: string;
  myThisWeekTaskDrawerId: string;
  myUpcomingTaskDrawerId: string;
  myCompletedTaskDrawerId: string;
  isFromAuditView?: boolean;
  isFromAuditCaseView?: boolean;
  isCaseDetailPopupVisible?: boolean;
  eaRoundId: number;
  doNotLoadDatasourcesInd: boolean;
  attachedLevelTitleName?: string;
  isUserTaskListGridSetFiltered?: boolean;
}
const IS_TASK_CARD_VIEW_VISIBLE_KEY = "isTaskCardViewVisible";
const AuditViewUserTaskList: React.FC<IAuditViewUserTaskList> = (props) => {
  let auditViewUserTaskListConfig = useSelector(
    (state: any) =>
      state["auditViewUserTaskListReducer"].auditViewUserTaskListConfig,
    isEqual
  );
  auditViewUserTaskListConfig = auditViewUserTaskListConfig
    ? auditViewUserTaskListConfig
    : {};
  let isShowCardView =
    auditViewUserTaskListConfig[props.myTaskWidgetId]?.isShowCardView;
  if (props.isFromAuditView && typeof isShowCardView === "undefined") {
    isShowCardView = true;
  }
  const defaultStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].defaultStatusValue,
    isEqual
  );
  const userTaskPopupMode = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskPopupMode,
    isEqual
  );
  const includeNonAttachedLevelTasks = useSelector(
    (state: any) => state["userTaskListReducer"].includeNonAttachedLevelTasks,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const hasEditAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_PROPERTY_EDITING], currentUser),
    [currentUser]
  );
  const isAddUserTaskPopupVisible = useSelector(
    (state) => state["userTaskListReducer"].isAddUserTaskPopupVisible,
    isEqual
  );
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  const caseData = useMemo(() => {
    if (props.attachedLevelName === "EAC") {
      return {
        eaCaseId: props.attachedLevelId,
      };
    } else {
      return {
        eaCaseId: "",
      };
    }
  }, [props.attachedLevelId, props.attachedLevelName]);

  const refreshListHandler = () => {
    asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
      attachedLevelId: props.attachedLevelId,
      attachedLevelName: props.attachedLevelName,
      includeNonAttachedLevelTasks: includeNonAttachedLevelTasks,
      taskDataPrefix: props.attachedLevelName === "EAC" ? props.attachedLevelId : null,
    });
  };
  useEffect(() => {
    if (!props.doNotLoadDatasourcesInd) {
      asyncAction.asyncOperationStart(GET_ATTACHMENT_LEVEL_LIST, {});
      asyncAction.asyncOperationStart(GET_AUDITOR_LIST, {});
      asyncAction.asyncOperationStart(GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP, {});
      asyncAction.asyncOperationStart(GET_EXTERNAL_USER_GROUP_LIST, {});
      asyncAction.asyncOperationStart(GET_TASK_GROUP_LIST, {});
    }
    dispatch(
      actions.asyncOperationStart(GET_USER_TASK_DATASOURCE, {
        attachedLevelId: props.attachedLevelId,
        attachedLevelName: props.attachedLevelName,
        attachedLevel: props.attachedLevelName,
      })
    );
  }, []);

  useEffect(() =>{
    getUserPreference(IS_TASK_CARD_VIEW_VISIBLE_KEY).then(({settings}) => {
      if (settings) {
        dispatch({
          type: TOGGLE_CARD_VIEW_SWITCH,
          data: {
            isShowCardView: settings !== "false",
            myTaskWidgetId: props.myTaskWidgetId,
          },
        });
      }
    });
  }, [])
  const toggleUserTaskPopup = (dispatch,isVisible, title, mode) => {
    dispatch({
      type: TOGGLE_ADD_USER_TASK_POPUP,
      data: {
        userTaskPopupMode: mode,
        userTaskPopupTitle: title,
        isAddUserTaskPopupVisible: isVisible,
      },
    });
    if (!isVisible) {
      refreshListHandler();
    }
  };
  return (
    <div className={"audit-view-user-task-list-container"}>
      <div className={"audit-view-user-task-list-view-switch-parent-container"}>
        <div
          className={"audit-view-user-task-list-view-switch-container"}
          style={{ display: "flex", marginRight: "19px" }}
        >
          {isShowCardView && hasEditAccess && (
            <div
              title="Add New Task"
              className="fa fa-plus application-section-primary-color add-new-task-icon"
              onClick={() => {
                dispatch(
                  actions.asyncOperationStart(GET_ATTACHMENT_LEVEL_LIST, {})
                );
                dispatch(
                  actions.asyncOperationStart(GET_USER_TASK_STATUS_LIST, {})
                );
                dispatch({
                  type: SET_CURRENT_ATTACHED_LEVEL_DATA,
                  data: {
                    currentAttachedLevelId: props.attachedLevelId,
                    currentAttachedLevelName: props.attachedLevelName,
                  },
                });
                dispatch({
                  type: SET_USER_TASK_POPUP_MODE,
                  data: { userTaskPopupMode: USER_TASK_POPUP_MODE.ADD },
                });
                dispatch({
                  type: SET_USER_TASK_FORM_DATA,
                  data: {
                    userTaskFormData: {
                      statusId: defaultStatusValue,
                    },
                  },
                });
                dispatch({
                  type: SET_ASSIGNED_USER_TYPE,
                  data: {
                    assignedUserType: USER_TYPE.NORMAL,
                  },
                });
                resetAddTaskPopupValidation(dispatch);
                dispatch(
                  actions.asyncOperationStart(GET_USER_TASK_DATASOURCE, {
                    attachedLevelId: props.attachedLevelId,
                    attachedLevelName: props.attachedLevelName,
                    attachedLevel: props.attachedLevelName,
                  })
                );
                let title = "Add New Task";
                if (props.attachedLevelTitleName)
                  title += " - " + props.attachedLevelTitleName;
                toggleUserTaskPopup(dispatch,true, title, USER_TASK_POPUP_MODE.ADD);
              }}
            ></div>
          )}
          <div
            className={"audit-view-user-task-list-view-switch-label"}
            style={{ marginRight: "10px", fontWeight: "bold" }}
          >
            Card View:
          </div>
          <div>
            <MdaeSwitch
              value={isShowCardView}
              onValueChanged={(e) => {
                if (e.event){
                  setUserPreference(IS_TASK_CARD_VIEW_VISIBLE_KEY, e.value);
                  dispatch({
                    type: TOGGLE_CARD_VIEW_SWITCH,
                    data: {
                      isShowCardView: e.value,
                      myTaskWidgetId: props.myTaskWidgetId,
                    },
                  });
                }
              }}
            ></MdaeSwitch>
          </div>
        </div>
      </div>
      <div style={{ display: isShowCardView ? "none" : "block" }}>
        <UserTaskList
          attachedLevelId={props.attachedLevelId}
          attachedLevelName={props.attachedLevelName}
          attachedLevelTitleName={props.attachedLevelTitleName}
          includeNonAttachedLevelTasks={props.includeNonAttachedLevelTasks}
          isUserTaskChartVisible={false}
          isUserTaskBulkOptionVisible={true}
          myTaskWidgetId={props.myTaskWidgetId}
          auditGroupId={props.auditGroupId}
          isManagerView={props.isManagerView}
          isFromAuditView={true}
          doNotLoadDatasourcesInd={props.doNotLoadDatasourcesInd}
          excelExportFileName={props.myTaskWidgetId}
          refreshUserTaskListFunction={refreshListHandler}
          caseData={caseData}
        ></UserTaskList>
      </div>
      <div style={{ display: isShowCardView ? "block" : "none" }}>
        <UserTaskCardView
          myTaskWidgetId={props.myTaskWidgetId}
          doNotLoadDatasourcesInd={props.doNotLoadDatasourcesInd}
          myPastDueTaskDrawerId={props.myPastDueTaskDrawerId}
          myThisWeekTaskDrawerId={props.myThisWeekTaskDrawerId}
          myUpcomingTaskDrawerId={props.myUpcomingTaskDrawerId}
          myCompletedTaskDrawerId={props.myCompletedTaskDrawerId}
          groupByPropertyName={"assignedToUserName"}
          isFromMyAuditView={true}
          refreshListHandler={() => {
            refreshListHandler();
            dispatch({
              type: SET_REFRESH_AUDIT_SUMMARY_DATA,
              data: true,
            });
          }}
        ></UserTaskCardView>
      </div>
      {isAddUserTaskPopupVisible &&
        props.isFromAuditView &&
        !props.isCaseDetailPopupVisible && (
          <AddUserTaskPopup
            toggleUserTaskPopup={toggleUserTaskPopup}
            auditGroupId={props.auditGroupId}
            isManagerView={false}
            isFromMyTaskPage={false}
            isFromUserTaskList={true}
            isRefreshExternalAuditSummaryData={true}
            eaRoundId={props.eaRoundId}
            attachedLevelId={props.attachedLevelId}
            attachedLevelName={props.attachedLevelName}
            refreshCaseListFromDb={refreshCaseListFromDb}
          ></AddUserTaskPopup>
        )}
      {isAddUserTaskPopupVisible &&
        props.isFromAuditCaseView &&
        props.isCaseDetailPopupVisible && (
          <AddUserTaskPopup
            toggleUserTaskPopup={toggleUserTaskPopup}
            auditGroupId={props.auditGroupId}
            isManagerView={false}
            isFromMyTaskPage={false}
            isFromUserTaskList={true}
            refreshUserTaskListFunction={refreshListHandler}
            isRefreshExternalAuditSummaryData={true}
            eaRoundId={props.eaRoundId}
            attachedLevelId={props.attachedLevelId}
            attachedLevelName={props.attachedLevelName}
          ></AddUserTaskPopup>
        )}
    </div>
  );
};
export default AuditViewUserTaskList;
